// extracted by mini-css-extract-plugin
export default {"price-infobox":"ExpandedRowDtoListOfferPrice_price-infobox__Kz9Gy"};